module.exports = __webpack_public_path__ + "img/not_found_data.777c5036.png";